<template>
	<!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：关键词回复-添加
    -->
	<el-dialog title="添加关键词回复" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
		:close-on-press-escape="false">
		<el-form size="small" :model="form" :rules="formRules" ref="form">
			<el-form-item label="规则名称" prop="name" :label-width="formLabelWidth">
				<el-input v-model="form.name" autocomplete="off" placeholder="请输入规则名称"></el-input>
			</el-form-item>
			<el-form-item label="关键词" prop="keyword" :label-width="formLabelWidth">
				<!-- <el-input v-model="form.keyword" autocomplete="off" placeholder="关键词，多个以逗号分割"></el-input> -->
				<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
					@close="handleClose(tag)">
					{{tag}}
				</el-tag>
				<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
					@keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
				</el-input>
				<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 点击添加</el-button>
			</el-form-item>
			<el-form-item label="匹配方式" prop="matching_type" :label-width="formLabelWidth">
				<el-radio-group v-model="form.matching_type">
					<el-radio :label="1">全匹配</el-radio>
					<el-radio :label="2">模糊匹配</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="回复内容" prop="content" :label-width="formLabelWidth">
				<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 4}" placeholder="请输入内容"
					v-model="form.content">
				</el-input>
			</el-form-item>
			<el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
				<el-input v-model.number="form.sort" autocomplete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible">取 消</el-button>
			<el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import AppSettingApi from "@/api/appsetting.js";
	export default {
		data() {
			return {
				form: {
					parent_id: "0",
					name: "",
					keyword: '', // 关键词，多个以逗号分割
					matching_type: 1, // 匹配方式：1-全匹配；2-模糊匹配
					content: '',
					sort: 1,
				},
				formRules: {
					name: [{
						required: true,
						message: "请输入分类名称",
						trigger: "blur"
					}],
					keyword: [{
						required: true,
						message: "请添加关键词",
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: "请输入内容",
						trigger: "blur"
					}],
					sort: [{
							required: true,
							message: "分类排序不能为空"
						},
						{
							type: "number",
							message: "分类排序必须为数字"
						}
					]
				},
				/*左边长度*/
				formLabelWidth: "120px",
				/*是否显示*/
				dialogVisible: false,
				loading: false,
				dynamicTags: [],
				inputVisible: false,
				inputValue: ''
			};
		},
		props: ["open_add", "addform"],
		created() {
			this.dialogVisible = this.open_add;
		},
		methods: {
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
				this.form.keyword = this.dynamicTags.join(",")
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
				this.form.keyword = this.dynamicTags.join(",")
			},
			/*添加用户*/
			addUser() {
				let self = this;
				let params = self.form;
				self.$refs.form.validate(valid => {
					if (valid) {
						self.loading = true;
						AppSettingApi.replyAdd(params)
							.then(data => {
								self.loading = false;
								self.$message({
									message: "添加成功",
									type: "success"
								});
								self.dialogFormVisible(true);
							})
							.catch(error => {
								self.loading = false;
							});
					}
				});
			},

			/*关闭弹窗*/
			dialogFormVisible(e) {
				if (e) {
					this.$emit("closeDialog", {
						type: "success",
						openDialog: false
					});
				} else {
					this.$emit("closeDialog", {
						type: "error",
						openDialog: false
					});
				}
			},
		}
	};
</script>

<style scoped>
	.img {
		margin-top: 10px;
	}

	.el-tag+.el-tag {
		margin-left: 20px;
	}

	.button-new-tag {
		margin-left: 20px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 20px;
		vertical-align: bottom;
	}
</style>


// WEBPACK FOOTER //
// src/views/appsetting/official/add.vue